import { ValueOf } from "../type";

export const FolderKey = {
  BrowseFolders: "BROWSE_FOLDERS",
  BrowseFoldersMoveResource: "BROWSE_FOLDERS_MOVE_RESOURCE",
  BrowseFoldersEConsentSchedule: "BROWSE_FOLDERS_ECONSENT_SCHEDULE",
  FolderById: "FOLDER_BY_ID",
  FoldersSummary: "FOLDERS_SUMMARY",
  MyRoleForFolderById: "MY_ROLE_FOR_FOLDER_BY_ID",
  MyRoleForFolderFileById: "MY_ROLE_FOR_FOLDER_FILE_BY_ID",
} as const;

export type FolderKeyType = ValueOf<typeof FolderKey>;
